<template>
  <v-btn
    small
    right
    class="ml-4"
    :data-test="`${dataTest}Add`"
    @click="createNew"
  >
    Добавить
  </v-btn>
</template>
<script>
import { NestedEditorsEventBus } from "../nested-editors/nested-editors-event-bus.js";
import { getReference } from "../../backend/referenceApi.js";

export default {
  props: ["label", "resource", "componentName", "dataTest"],
  data() {
    return {};
  },
  created() {
    NestedEditorsEventBus.$on("create-" + this._uid, createdId => {
      const res = this.getData(createdId);
      this.$emit("change", res);
    });
  },
  methods: {
    createNew() {
      const vMenu = this.$children[0].$children.find(
        c => c.$options.name === "v-menu",
      );
      if (vMenu) {
        vMenu.$data.isActive = false;
      }
      NestedEditorsEventBus.$emit("open", {
        title: this.label,
        uid: this._uid,
        component: this.componentName,
      });
    },
    async getData(id) {
      const res = await getReference(this.resource, id);
      return res;
    },
  },
};
</script>
